var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-title"},[_c('span',{class:'one ' +(_vm.icon ||' one-notebook')}),_c('label',{staticClass:"title-container"},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))])]),_c('span',{staticClass:"tip-content"},[_vm._v(" "+_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }